import React from 'react';
import './App.css';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Items from './pages/Items';
import Issue from './pages/Issue';
import Return from './pages/Return';
import Reports from './pages/Reports';
import About from './pages/About';
import Login from './pages/Login';
import { clearAuthSession, isAuthenticated, setupAxiosAuth } from './utils/auth';

function AppShell({ onLogout }) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="app-container">
      <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} onLogout={onLogout} />
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
      <div className="app-body">
        <Sidebar isOpen={sidebarOpen} onNavigate={closeSidebar} onClose={closeSidebar} />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/students" element={<Students />} />
            <Route path="/items" element={<Items />} />
            <Route path="/issue" element={<Issue />} />
            <Route path="/return" element={<Return />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  const [authenticated, setAuthenticated] = React.useState(isAuthenticated());

  React.useEffect(() => {
    // Require login on every fresh app open.
    clearAuthSession();
    setAuthenticated(false);
  }, []);

  React.useEffect(() => {
    const cleanup = setupAxiosAuth(() => {
      setAuthenticated(false);
    });

    return cleanup;
  }, []);

  React.useEffect(() => {
    setAuthenticated(isAuthenticated());
  }, []);

  const handleLogout = () => {
    clearAuthSession();
    setAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={authenticated ? <Navigate to="/" replace /> : <Login onLoginSuccess={() => setAuthenticated(true)} />}
        />
        <Route
          path="*"
          element={authenticated ? <AppShell onLogout={handleLogout} /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
